import React, { useState } from "react";
import "./CompleteForm.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { useNavigate } from "react-router-dom";

export default function CompleteForm() {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleEnterClass = () => {
    navigate("/home");
  };
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageHeader centeredFlex">
          <BackBtn />
        </div>
        <div className="pageWrapper">
          <div className="completeFormTop centeredFlex">
            <img src="/images/success.png" alt="success" />
            <span>از صبوری شما ممنونم</span>
          </div>
          <div className="completeFormBottom">
            <button
              className="completeFormBtn"
              onClick={handleEnterClass}
              style={isChecked ? { display: "block" } : { display: "none" }}
            >
              برای ورود به کلاس کلیک کنید!
            </button>
            <label className="completeFormCheck responsiveWidth">
              <input
                type="checkbox"
                className="radioBtn"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span className="customRadioBtn completeFormRadioBtn"></span>
              <span className="completeFormCheckText">
                در هشیاری کامل اطلاعات را پر کردم
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
